import type { FaireProductEntity } from "../../entity_types/product";

export const p_gn4btgyh9b: FaireProductEntity = {
  token: "p_gn4btgyh9b",
  type: "product",
  name: "Mini Wild Rose 3 oz. Candle",
  brandToken: "b_ambzy6ccke",
  brandName: "Night Blooms Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/2b6cf3b0ba5496fb0a0a2e5ad2449cb9f989338bc85237fa4ac817d10d1fef62.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7221991432e1d9d25f26a3f1002b4b4c9f98f4c0c6af5834ca86be0ea1a0fc4d.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "Wild Rose is free-spirited floral in full bloom. Bright basil and grapefruit lift a base of lush damask rose, softened by hints of magnolia. Grounded with a touch of earthy patchouli, capturing the essence of an entire rose from petal to stem.\n\n• 100% natural soy wax\n• Non-toxic + phthalate free\n• Braided cotton wick\n• Extended burn 20+ hours\n• Hand poured in Ojai, California",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:44:27.053Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
